import { Cookie } from 'constants/cookies';

import { getCookie } from './cookies';

export function isWiXIntegration(): boolean {
  const utmCookie = getCookie(Cookie.UtmSource);

  return utmCookie === 'wix.com';
}
